import useAuth from "./useAuth";
import usePageVisible from "./usePageVisible";
import { useMessagesUnreadCountQuery } from "../store/messageApi";

const POLL_MS = 60 * 1000;

/**
 * Okunmamış hasta mesajı olan konuşma sayısı (Sidebar rozeti).
 * `enabled` false ise (izin / modül yok) hiç istek atılmaz.
 */
export default function useMessagesUnreadCount(enabled) {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const visible = usePageVisible();
  const { data } = useMessagesUnreadCountQuery(
    { token },
    { skip: !enabled || !token, pollingInterval: visible ? POLL_MS : 0 }
  );
  return enabled ? data?.data?.conversations || 0 : 0;
}
